import React, {
  useState,
  useRef,
  useEffect
} from "react";

import { Link } from "react-router-dom";

import {
  Grip,
  LogIn,
} from "lucide-react";

import { FcGoogle } from "react-icons/fc";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faEnvelope,
  faBell,
  faBriefcase,
  faNewspaper,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";

import {
  FaFacebookF,
  FaYoutube,
  FaLinkedinIn,
  FaInstagram,
  FaBars,
  FaTimes,
} from "react-icons/fa";

import {
  FiChevronDown,
  FiChevronRight,
} from "react-icons/fi";


/* =========================================================
   MENU DATA
========================================================= */

const menuItems = [
  {
    title: "About",
    link: "#",
    submenu: [
      {
        title: "Brief History",
        link: "/about",
      },

      {
        title: "Message",
        link: "#",
        submenu: [
          {
            title: "Message from Vice Chancellor",
            link: "/vc-message",
          },
          {
            title: "Message from Pro VC",
            link: "/provc-message",
          },
          {
            title: "Message from Treasurer",
            link: "/treasurer-message",
          },
          {
            title: "Message from Chief Advisor",
            link: "/advisor-message",
          },
          {
            title: "Message from Founder & Chairman",
            link: "/founder-message",
          },
          {
            title: "Message from Secretary BoT",
            link: "/chairman-message",
          },
          {
            title: "Message from Registrar",
            link: "/registrar-message",
          },
        ],
      },

      {
        title: "Overview of UCTC",
        link: "/overview",
      },

      {
        title: "Executive Leaders",
        link: "/executive-leader",
      },

      {
        title: "MoU and MoA",
        link: "/mou-moa",
      },

      {
        title: "FAQ",
        link: "/faq",
      },
    ],
  },

  {
    title: "Adminisitration",
    link: "#",
    submenu: [
      {
        title: "The Chancellor",
        link: "/administration/chancellor",
      },

      {
        title: "The Vice Chancellor",
        link: "/administration/vc",
      },

      {
        title: "The Pro Vice Chancellor",
        link: "/administration/pro-vc",
      },

      {
        title: "The Treasurer",
        link: "/administration/treasurer",
      },

      {
        title: "The Registrar",
        link: "/administration/registrar",
      },

      {
        title: "Syndicate",
        link: "/administration/syndicate",
      },

      {
        title: "Academic Council",
        link: "/administration/academic-council",
      },

      {
        title: "Deans of Faculties",
        link: "/administration/deans",
      },

      {
        title: "Proctors",
        link: "/administration/proctors",
      },

      {
        title: "Controller of Examination",
        link: "/administration/coe",
      },

      {
        title: "Divisions",
        link: "#",
        submenu: [
          {
            title: "Admission Division",
            link: "/administration/admission",
          },

          {
            title: "Accounts & Finance Division",
            link: "/administration/accounts",
          },

          {
            title: "Student Affairs Division",
            link: "/administration/sad",
          },

          {
            title: "Cultural Affairs Division",
            link: "/administration/cad",
          },

          {
            title: "Information Technology Division",
            link: "/administration/itd",
          },

          {
            title: "Library and Information Division",
            link: "/administration/lid",
          },
        ],
      },
	  
	  {
        title: "Committee",
        link: "#",
        submenu: [
          {
            title: "Anti-Sexual Harassment Committee",
            link: "/committee/sexual-harassment",
          },
        ],
      },
	  
    ],
  },

  {
    title: "Admission",
    link: "#",
    submenu: [
      {
        title: "Admission Requirement and Schedule",
        link: "/admission-requirement",
      },

      {
        title: "Admission Test",
        link: "/admission-test",
      },

      {
        title: "Document Required for Admission",
        link: "/admission-documents",
      },

      {
        title: "Admission Procedure",
        link: "/admission-process",
      },

      {
        title: "Why Us?",
        link: "/why-us",
      },

      {
        title: "Enrol Online",
        link: "/apply-online",
      },

      {
        title: "Tuition and Others Fees",
        link: "/fees",
      },

      {
        title: "Scholarship and Financial Assistance",
        link: "/scholarship",
      },
    ],
  },

  {
    title: "Academic",
    link: "#",
    submenu: [
      {
        title: "Undergraduate",
        link: "#",

        submenu: [
          {
            title: "Bachelor of Business Administration (BBA)",
            link: "/programs/bba",
          },

          {
            title: "B.Sc in Civil Engineering",
            link: "/programs/civil",
          },

          {
            title: "B.Sc in Mehanical Engineering",
            link: "/programs/mechanical",
          },

          {
            title: "B.Sc in Computer Science & Engineering",
            link: "/programs/cse",
          },

          {
            title: "B.A (Hons) in English Language & Literature",
            link: "/programs/english",
          },

          {
            title: "B.Sc in Electrical & Electronic Engineering",
            link: "/programs/eee",
          },

          {
            title: "B.A (Hons) in Islamic Studies",
            link: "/programs/bis",
          },

          {
            title: "Bachelor of Hospitality and Tourism Management",
            link: "/programs/htm",
          },
		  {
            title: "B.Sc in Textile Engineering",
            link: "/programs/bte",
          },
        ],
      },

      {
        title: "Graduate Program",
        link: "#",

        submenu: [
          {
            title: "Master of Business Administration",
            link: "/programs/mba",
          },

          {
            title: "Master of Public Health",
            link: "/programs/mph",
          },

          {
            title: "Master of Islamic Studies",
            link: "/programs/mis",
          },
        ],
      },

      {
        title: "Faculty",
        link: "#",

        submenu: [
          {
            title: "School of Business",
            link: "/faculties/business",
          },

          {
            title: "School of Science and Engineering",
            link: "/faculties/science",
          },

          {
            title: "School of Arts & Social Science",
            link: "/faculties/humanities",
          },
        ],
      },

      {
        title: "Academic",
        link: "#",

        submenu: [
          {
            title: "Academic System",
            link: "/academic-system",
          },

          {
            title: "Academic Policy",
            link: "/academic-policy",
          },

          {
            title: "Academic Calendar",
            link: "/academic-calendar",
          },
        ],
      },
    ],
  },

  {
    title: "Contact",
    link: "/contact",
  },
];


/* =========================================================
   SHORTCUT DATA
========================================================= */

const shortcutData = [
  {
    title: "Student Portal",
    link: "https://web.uctc.edu.bd/login",
  },

  {
    title: "Library",
    link: "https://opac.uctc.edu.bd",
  },

  {
    title: "University Repository",
    link: "https://dspace.uctc.edu.bd",
  },

  {
    title: "Career Services",
    link: "/career",
  },

  {
    title: "OCSAR",
    link: "/alumni",
  },

  {
    title: "Research",
    link: "/research",
  },

  {
    title: "IQAC",
    link: "/iqac",
  },
];


/* =========================================================
   HEADER
========================================================= */

export default function Header() {

  const [menuOpen, setMenuOpen] = useState(false);

  const [shortcutOpen, setShortcutOpen] =
    useState(false);

  const [openSubmenu, setOpenSubmenu] =
    useState(null);

  const [loading, setLoading] =
    useState(false);


  /*
   * Stores position of each sub-submenu.
   *
   * Example:
   *
   * {
   *   "3-0": {
   *      horizontal: "right",
   *      vertical: "top"
   *   }
   * }
   */
  const [submenuPosition, setSubmenuPosition] =
    useState({});


  /*
   * Store references to submenu elements.
   */
  const submenuRefs = useRef({});


  /* =====================================================
     MAIN MENU CLICK
  ===================================================== */

  const handleMenuClick = (idx) => {

    setOpenSubmenu(
      openSubmenu === idx
        ? null
        : idx
    );

  };


  /* =====================================================
     CALCULATE SUB-SUBMENU POSITION
  ===================================================== */

  const calculateSubmenuPosition = (
    key,
    parentElement
  ) => {

    if (!parentElement) {
      return;
    }


    const submenu =
      submenuRefs.current[key];


    if (!submenu) {
      return;
    }


    const parentRect =
      parentElement.getBoundingClientRect();


    const submenuRect =
      submenu.getBoundingClientRect();


    const viewportWidth =
      window.innerWidth;


    const viewportHeight =
      window.innerHeight;


    const margin = 8;


    /* =================================================
       HORIZONTAL POSITION
    ================================================= */

    const spaceRight =
      viewportWidth -
      parentRect.right;


    const spaceLeft =
      parentRect.left;


    let horizontal =
      "right";


    /*
     * If submenu doesn't fit on right,
     * open it on left.
     */

    if (
      spaceRight <
      submenuRect.width + margin
    ) {

      if (
        spaceLeft >=
        submenuRect.width + margin
      ) {

        horizontal = "left";

      }

    }


    /* =================================================
       VERTICAL POSITION
    ================================================= */

    const spaceBelow =
      viewportHeight -
      parentRect.top;


    const spaceAbove =
      parentRect.bottom;


    let vertical =
      "top";


    /*
     * Normal:
     *
     * parent
     * └── submenu
     */

    if (
      spaceBelow >=
      submenuRect.height + margin
    ) {

      vertical = "top";

    }

    /*
     * Not enough space below.
     *
     * Open upward.
     *
     *       submenu
     *          ↑
     *       parent
     */

    else if (
      spaceAbove >=
      submenuRect.height + margin
    ) {

      vertical = "bottom";

    }

    /*
     * Neither side has enough space.
     *
     * Use top but limit submenu height.
     */

    else {

      vertical = "top";

    }


    setSubmenuPosition(
      (prev) => ({
        ...prev,

        [key]: {
          horizontal,
          vertical,
        },
      })
    );

  };


  /* =====================================================
     HANDLE SUB-SUBMENU HOVER
  ===================================================== */

  const handleSubmenuMouseEnter = (
    key,
    event
  ) => {

    /*
     * Wait until browser has rendered
     * the submenu so we can measure it.
     */

    requestAnimationFrame(() => {

      calculateSubmenuPosition(
        key,
        event.currentTarget
      );

    });

  };


  /* =====================================================
     RECALCULATE ON WINDOW RESIZE
  ===================================================== */

  useEffect(() => {

    const handleResize = () => {

      Object.keys(
        submenuRefs.current
      ).forEach((key) => {

        const element =
          submenuRefs.current[key];

        if (!element) {
          return;
        }


        const parent =
          element.parentElement;


        if (parent) {

          calculateSubmenuPosition(
            key,
            parent
          );

        }

      });

    };


    window.addEventListener(
      "resize",
      handleResize
    );


    return () => {

      window.removeEventListener(
        "resize",
        handleResize
      );

    };

  }, []);


  /* =====================================================
     GOOGLE LOGIN
  ===================================================== */

  const handleGoogleLogin = async () => {

    setLoading(true);

    try {

      const res =
        await fetch(
          "https://www.uctc.edu.bd/login/google"
        );


      const data =
        await res.text();


      if (
        data.startsWith("http")
      ) {

        window.location.href =
          data;

      }

      else {

        console.error(
          "Invalid redirect URL:",
          data
        );

        alert(
          "Unable to get Google login link."
        );

      }

    }

    catch (err) {

      console.error(
        "Login error:",
        err
      );

      alert(
        "Something went wrong. Try again later."
      );

    }

    finally {

      setLoading(false);

    }

  };


  /* =====================================================
     MOBILE MENU ITEM
  ===================================================== */

  const MobileMenuItem = ({
    item,
  }) => {

    const [open, setOpen] =
      useState(false);


    const handleClick = (
      e
    ) => {

      if (item.submenu) {

        e.preventDefault();

        setOpen(!open);

      }

    };


    return (

      <li>

        {/* Main item */}

        <div
          className="
            flex
            justify-between
            items-center
            py-2
            cursor-pointer
          "
          onClick={handleClick}
        >

          <a
            href={item.link}
            className="flex-1"
          >
            {item.title}
          </a>


          {item.submenu && (

            <FiChevronDown
              className={`
                transition-transform
                duration-200
                ${
                  open
                    ? "rotate-180"
                    : ""
                }
              `}
            />

          )}

        </div>


        {/* Recursive submenu */}

        {item.submenu &&
          open && (

            <ul
              className="
                pl-4
                border-l
                border-green-300
                ml-2
                space-y-1
              "
            >

              {item.submenu.map(
                (
                  sub,
                  idx
                ) => (

                  <MobileMenuItem
                    key={idx}
                    item={sub}
                  />

                )
              )}

            </ul>

          )}

      </li>

    );

  };


  /* =====================================================
     RETURN
  ===================================================== */

  return (

    <header
      className="
        w-full
        sticky
        top-0
        z-50
      "
    >

      {/* =================================================
          SLIM HEADER
      ================================================= */}

      <div
        className="
          bg-[#016C94]
          text-white
          text-sm
          px-4
          py-2
          flex
          justify-between
          items-center
        "
      >

        <div
          className="
            flex
            gap-3
            items-center
          "
        >

          <a
            href="https://www.facebook.com/UCTCBD/"
            className="px-1 py-1"
          >
            <FaFacebookF />
          </a>


          <a
            href="https://www.youtube.com/@uctcbd"
            className="px-1 py-1"
          >
            <FaYoutube />
          </a>


          <a
            href="https://www.linkedin.com/school/uctcbd/"
            className="px-1 py-1"
          >
            <FaLinkedinIn />
          </a>


          <a
            href="#"
            className="px-1 py-1"
          >
            <FaInstagram />
          </a>


          {/* Mobile Notice */}

          <a
            href="/all-notice"
            className="
              md:hidden
              hover:text-orange-500
            "
          >
            <FontAwesomeIcon
              icon={faBell}
            />
            {" "}
            Notice
          </a>


          {/* Mobile News */}

          <a
            href="/all-news"
            className="
              md:hidden
              hover:text-orange-500
            "
          >
            <FontAwesomeIcon
              icon={faNewspaper}
            />
            {" "}
            News
          </a>


          {/* Mobile Career */}

          <a
            href="/career"
            className="
              md:hidden
              hover:text-orange-500
            "
          >
            <FontAwesomeIcon
              icon={faBriefcase}
            />
            {" "}
            Career
          </a>


          {/* Google Login */}

          <button
            onClick={
              handleGoogleLogin
            }
            disabled={loading}
            className="
              hidden
              md:flex
              items-center
              justify-center
              gap-2
              px-1
              rounded-lg
              shadow-sm
              hover:bg-[#016C94]
              transition-all
              disabled:opacity-60
              cursor-pointer
            "
          >

            <FcGoogle size={22} />

            <span
              className="
                font-medium
                text-white
              "
            >
              {loading
                ? "Connecting..."
                : "Login with Google"}
            </span>

          </button>


          <a
            href="https://tehi.uctc.ac.bd"
            className="px-1 py-1"
          >
            TEHI-2026
          </a>

        </div>


        {/* Desktop right side */}

        <div
          className="
            hidden
            md:flex
            items-center
            gap-4
          "
        >

          <span>
            📞 +880 1707508080
          </span>

          <span>
            📞 +880 1707508081
          </span>

          <span>
            ✉ info@uctc.edu.bd
          </span>


          <a
            href="/alumni"
            className="hover:text-orange-500"
          >
            <FontAwesomeIcon
              icon={faUserGroup}
            />
            {" "}
            OCSAR
          </a>


          <a
            href="/all-notice"
            className="hover:text-orange-500"
          >
            <FontAwesomeIcon
              icon={faBell}
            />
            {" "}
            Notice
          </a>


          <a
            href="/all-news"
            className="hover:text-orange-500"
          >
            <FontAwesomeIcon
              icon={faNewspaper}
            />
            {" "}
            News
          </a>


          <a
            href="/career"
            className="hover:text-orange-500"
          >
            <FontAwesomeIcon
              icon={faBriefcase}
            />
            {" "}
            Career
          </a>


          <a
            href="http://mail.google.com"
            className="hover:text-orange-500"
          >
            <FontAwesomeIcon
              icon={faEnvelope}
            />
            {" "}
            Webmail
          </a>

        </div>

      </div>


      {/* =================================================
          NAVBAR
      ================================================= */}

      <nav
        className="
          bg-[#6BCCF2]
          px-4
          py-3
          flex
          justify-between
          items-center
          shadow-md
        "
      >

        {/* Logo */}

        <div
          className="
            flex
            items-center
            gap-3
          "
        >

          <a href="/">

            <img
              src="/img/uctc-head-logo.png"
              alt="Logo"
              className="
                h-12
                bg-white
                rounded-lg
                p-2
                shadow-lg
              "
            />

          </a>

        </div>


        {/* =================================================
            DESKTOP MENU
        ================================================= */}

        <ul
          className="
            hidden
            md:flex
            gap-6
            font-semibold
            text-gray-700
          "
        >

          {menuItems.map(
            (
              item,
              idx
            ) => (

              <li
                key={idx}
                className="relative"
              >

                {/* Main menu */}

                {item.submenu ? (

                  <button
                    onClick={() =>
                      handleMenuClick(idx)
                    }
                    className="
                      flex
                      items-center
                      gap-1
                      hover:text-green-700
                    "
                  >

                    {item.title}


                    <FiChevronDown
                      className={`
                        transition-transform
                        duration-200
                        ${
                          openSubmenu === idx
                            ? "rotate-180"
                            : ""
                        }
                      `}
                    />

                  </button>

                ) : (

                  <Link
                    to={item.link}
                    className="
                      flex
                      items-center
                      gap-1
                      hover:text-green-700
                    "
                  >
                    {item.title}
                  </Link>

                )}


                {/* =================================================
                    FIRST LEVEL SUBMENU
                ================================================= */}

                {item.submenu && (

                  <ul
                    className={`
                      absolute
                      left-0
                      mt-2
                      bg-[#F0FCFF]
                      border
                      border-[#C6F0FD]
                      shadow-md
                      rounded
                      transform
                      transition-all
                      duration-200
                      origin-top
                      min-w-[300px]
                      z-[100]

                      ${
                        openSubmenu === idx
                          ? "scale-y-100 opacity-100"
                          : "scale-y-0 opacity-0 pointer-events-none"
                      }
                    `}
                  >

                    {/* Arrow */}

                    <li
                      className="
                        absolute
                        -top-[6px]
                        left-3
                        w-3
                        h-3
                        bg-[#f9f9fb]
                        rotate-45
                        pointer-events-none
                        border-l
                        border-t
                        border-[#a6892f]
                      "
                    />


                    {item.submenu.map(
                      (
                        sub,
                        subIdx
                      ) => {

                        const key =
                          `${idx}-${subIdx}`;


                        const position =
                          submenuPosition[
                            key
                          ] || {
                            horizontal: "right",
                            vertical: "top",
                          };


                        return (

                          <li
                            key={subIdx}

                            onMouseEnter={
                              sub.submenu
                                ? (e) =>
                                    handleSubmenuMouseEnter(
                                      key,
                                      e
                                    )
                                : undefined
                            }

                            className="
                              px-4
                              py-2
                              hover:bg-green-100
                              relative
                              group
                              flex
                              justify-between
                              items-center
                              border-b
                              border-green-100
                            "
                          >

                            {/* Item */}

                            <a
                              href={sub.link}
                              className="
                                flex-1
                              "
                            >
                              {sub.title}
                            </a>


                            {/* Chevron */}

                            {sub.submenu && (

                              <FiChevronRight
                                className={`
                                  ml-2
                                  flex-shrink-0
                                  transition-transform
                                  ${
                                    position.horizontal ===
                                    "left"
                                      ? "rotate-180"
                                      : ""
                                  }
                                `}
                              />

                            )}


                            {/* =================================================
                                SUB-SUBMENU
                            ================================================= */}

                            {sub.submenu && (

                              <ul
                                ref={(el) => {

                                  submenuRefs.current[
                                    key
                                  ] = el;

                                }}

                                className={`
                                  absolute

                                  ${
                                    position.horizontal ===
                                    "left"
                                      ? "right-full mr-1"
                                      : "left-full ml-1"
                                  }

                                  ${
                                    position.vertical ===
                                    "bottom"
                                      ? "bottom-0"
                                      : "top-0"
                                  }

                                  hidden
                                  group-hover:block

                                  bg-white

                                  border
                                  border-gray-200

                                  shadow-lg

                                  rounded-md

                                  min-w-[300px]

                                  max-w-[calc(100vw-16px)]

                                  max-h-[calc(100vh-16px)]

                                  overflow-y-auto

                                  z-[200]
                                `}
                              >

                                {sub.submenu.map(
                                  (
                                    subsub,
                                    subsubIdx
                                  ) => (

                                    <li
                                      key={
                                        subsubIdx
                                      }
                                      className="
                                        px-4
                                        py-2
                                        hover:bg-green-100
                                        border-b
                                        border-green-100
                                      "
                                    >

                                      <a
                                        href={
                                          subsub.link
                                        }
                                        className="
                                          block
                                        "
                                      >
                                        {
                                          subsub.title
                                        }
                                      </a>

                                    </li>

                                  )
                                )}

                              </ul>

                            )}

                          </li>

                        );

                      }
                    )}

                  </ul>

                )}

              </li>

            )
          )}

        </ul>


        {/* =================================================
            RIGHT SIDE
        ================================================= */}

        <div
          className="
            flex
            items-center
            space-x-3
          "
        >

          {/* Shortcut */}

          <div className="relative">

            <button
              onClick={() =>
                setShortcutOpen(
                  !shortcutOpen
                )
              }
              className="
                p-2
                rounded-full
                bg-[#016C94]
                text-white
                hover:bg-[#014864]
              "
            >
              <Grip />
            </button>


            {shortcutOpen && (

              <div
                className="
                  absolute
                  right-0
                  mt-2
                  w-48
                  bg-[#F0FCFF]
                  border
                  border-[#C6F0FD]
                  rounded-xl
                  shadow-lg
                  overflow-hidden
                  z-50
                "
              >

                {shortcutData.map(
                  (
                    item,
                    idx
                  ) => (

                    <Link
                      key={idx}
                      to={item.link}
                      className="
                        block
                        px-4
                        py-2
                        hover:bg-[#f1e7c8]
                        text-[#333]
                      "
                    >
                      {item.title}
                    </Link>

                  )
                )}

              </div>

            )}

          </div>


          {/* Login */}

          <Link
            to="https://www.uctc.edu.bd/login"
            className="
              flex
              items-center
              bg-[#016C94]
              text-white
              px-4
              py-2
              rounded-xl
              hover:bg-green-700
            "
          >

            <LogIn
              className="
                w-4
                h-4
                mr-1
              "
            />

            Login

          </Link>


          {/* Mobile Menu */}

          <button
            className="
              md:hidden
              text-green-700
            "
            onClick={() =>
              setMenuOpen(
                !menuOpen
              )
            }
          >

            {menuOpen ? (

              <FaTimes
                size={22}
              />

            ) : (

              <FaBars
                size={22}
              />

            )}

          </button>

        </div>

      </nav>


      {/* =================================================
          MOBILE MENU
      ================================================= */}

      {menuOpen && (

        <ul
          className="
            md:hidden
            bg-[#fdfbf5]
            border
            border-[#a6892f]
            p-4
            space-y-2
            font-medium

            max-h-[calc(100vh-90px)]
            overflow-y-auto

            shadow-lg
          "
        >

          {menuItems.map(
            (
              item,
              idx
            ) => (

              <MobileMenuItem
                key={idx}
                item={item}
              />

            )
          )}

        </ul>

      )}

    </header>

  );

}